const modal = {
  settings: {
    modalName: 'information-modal',
    isCookie: null
  },
  init() {
    this.setModal();
  },
  setModal() {
    const modalCustom = document.querySelector('.modal-custom');

    if (!modalCustom) return;

    this.settings.isCookie = this.getCookie(this.settings.modalName);

    if (this.settings.isCookie) return;

    const modalCustomContainer = modalCustom.querySelector('.modal-custom__container');

    modalCustom.classList.add('active');

    const button = modalCustom.querySelector('a.button-custom');

    button?.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      this.setCookie(this.settings.modalName, true, balsamData.modal_cookie_expiration);

      const target = button.target ? button.target : '_self';
      const url = button.href;

      window.open(url, target);
      modalCustom.classList.remove('active');
    })

    const close = document.querySelector('.modal-custom__close');

    close.addEventListener('click', () => this.closeModal(this.settings.isCookie, modalCustom));

    window.addEventListener('keydown', e => {
      if ( e.key === 'Escape') {
        this.closeModal(this.settings.isCookie, modalCustom);
      }
    })

    // Prevent closing the modal on click
    modalCustomContainer.addEventListener('click', e => e.stopPropagation());

    document.addEventListener('click', () => {
      this.closeModal(this.settings.isCookie, modalCustom);
    })
  },
  closeModal(isCookie, modalCustom) {
    if (!isCookie) {
      this.setCookie(this.settings.modalName, true, balsamData.modal_cookie_expiration);
      this.settings.isCookie = this.getCookie(this.settings.modalName);

      modalCustom.classList.remove('active');
    }
  },
  setCookie(name, value, days) {
    let expires = '';

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${(value || '')}${expires}; path=/`;
  },
  getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  },
};

export default modal;
